import createReactComponent from '../createReactComponent';
var BluetoothSearching = createReactComponent('BluetoothSearching', [['path', {
  d: 'M7 7l10 10-5 5V2l5 5L7 17',
  key: '1ifnhf'
}], ['path', {
  d: 'M20.83 14.83a4 4 0 000-5.66',
  key: '7f1c9z'
}], ['path', {
  d: 'M18 12h.01',
  key: 'yjnet6'
}]]);
export default BluetoothSearching;